// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"145":"component---src-pages-projects-friendly-reader-tsx","245":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"145":"4b6d23fc4782d8e8765b","245":"5249807967b7f078fb05","522":"842aa10f7225a21b975e"}[chunkId] + ".js";
};